export default {
  'validation:email-is-valid': 'Bitte gib eine gültige E-Mail an.',
  'validation:phone-is-valid':
    'Deine Telefonnummer scheint nicht korrekt zu sein.',
  'validation:required': 'Bitte ausfüllen.',
  'validation:min-length-12': 'Bitte mindestens 12 Zeichen eingeben.',
  'validation:matches-password': 'Die Kennwörter stimmen nicht überein.',
  'validation:zip-is-valid': 'Ungültige PLZ',
  'validation:otp-must-be-x-digits':
    'Der Code muss genau {digits} Ziffern haben.',
  'validation:otp-invalid-code': 'Der eingegebene Code ist ungültig.',
  'validation:otp-too-many-attempts':
    'Zu viele Versuche. Bitte versuche es später erneut.',
  'validation:otp-unknown-error':
    'Leider ist ein Fehler aufgetreten. Bitte versuch es später erneut.',
  'validation:unknown':
    'Leider ist ein Fehler aufgetreten. Bitte versuch es später erneut.',
};
